import React from 'react';

import { labels } from '../configuration/labels';

import '../styles/scss/components/layout.scss';

const Header = () => {
  return (
    <div className="header-container">
      <img
        src="https://kingbakeryonline.com/upload-img/logo_king.png"
        alt="logo"
      />
      <a href="https://kingbakeryonline.com/">{labels.headerBtnBack}</a>
    </div>
  );
};

export default Header;
